import script from "./GroupByViews.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupByViews.vue?vue&type=script&setup=true&lang=js"

import "./GroupByViews.vue?vue&type=style&index=0&id=4195619e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4195619e"]])

export default __exports__